
import React, { useState } from 'react';
import { PricingCard } from './PricingCard';
import { pricingData } from '@/data/pricingData';
import { LeadFormModal } from '@/components/LeadFormModal';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export const ModernPricingSection = () => {
  const [showLeadForm, setShowLeadForm] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState<'foundation' | 'professional' | 'enterprise' | 'not_sure'>('not_sure');

  const handleSelectPlan = (packageName: 'foundation' | 'professional' | 'enterprise') => {
    setSelectedPackage(packageName);

    // Track analytics event
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'pricing_package_cta_clicked', {
        package: packageName
      });
    }

    // All tiers = sales-led (show lead form for quotes)
    setShowLeadForm(true);
  };

  return (
    <>
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Choose Your Camp Kitchen Plan
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Transparent pricing with no hidden fees. All plans include setup, training, and support — we'll help you choose the right fit for your camp size and season.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <PricingCard
              tier={pricingData.starter}
              onSelect={() => handleSelectPlan('foundation')}
            />
            <PricingCard
              tier={pricingData.premium}
              onSelect={() => handleSelectPlan('professional')}
            />
            <PricingCard
              tier={pricingData.enterprise}
              onSelect={() => handleSelectPlan('enterprise')}
            />
          </div>

          <div className="mt-16 max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-[#F5F1E8] to-ivory border-2 border-copper/20 rounded-2xl p-8 text-center">
              <p className="text-lg text-slate mb-6 leading-relaxed">
                <span className="font-semibold text-deep-teal">Need help choosing the right plan?</span>{' '}
                Our team can recommend the best fit based on your camp size and kitchen setup.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button 
                  asChild 
                  size="lg"
                  className="bg-copper hover:bg-copper/90 text-deep-teal font-semibold shadow-lg"
                >
                  <Link to="/contact">Request a Demo</Link>
                </Button>
                
                <Button 
                  asChild 
                  size="lg" 
                  variant="outline"
                  className="border-2 border-deep-teal text-deep-teal hover:bg-deep-teal/5"
                >
                  <Link to="/contact">Talk to Sales</Link>
                </Button>
              </div>
            </div>
          </div>

          <div className="text-center mt-8">
            <p className="text-sm text-gray-500">
              All packages include setup, training, and ongoing support tailored to your needs.
            </p>
            <p className="text-xs text-gray-400 mt-2">
              Already a customer? Contact your account manager for billing inquiries.
            </p>
          </div>
        </div>
      </section>

      <LeadFormModal
        open={showLeadForm}
        onClose={() => setShowLeadForm(false)}
        preselectedPackage={selectedPackage}
        sourcePage="pricing_page"
      />
    </>
  );
};
